/* DINOTY: starts every [data-dn-swiper] carousel.
   Config (JSON in the attribute): loop, speed, gap, spv, breakpoints {minWidth:{slidesPerView,spaceBetween}},
   autoplay {delay}, scrollbar (true), marquee (true = continuous, linear).
   Buttons .dn-sw-prev / .dn-sw-next are looked up inside the closest [data-dn-swiper-wrap]. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function maxSpv(c) {
    var m = c.spv || 1;
    var b = c.breakpoints || {};
    Object.keys(b).forEach(function (k) { if (b[k].slidesPerView > m) m = b[k].slidesPerView; });
    return m;
  }

  function start(el) {
    if (el.__dnSwiper || typeof Swiper === 'undefined') return;
    var c;
    try { c = JSON.parse(el.getAttribute('data-dn-swiper') || '{}'); } catch (e) { c = {}; }
    var wrap = el.closest('[data-dn-swiper-wrap]') || el.parentElement;
    var count = el.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
    var rtl = document.documentElement.dir === 'rtl';
    el.setAttribute('dir', rtl ? 'rtl' : 'ltr');

    var loop = !!c.loop && count > maxSpv(c);
    var opts = {
      loop: loop,
      speed: c.speed || 300,
      slidesPerView: c.spv || 1,
      spaceBetween: c.gap || 0,
      breakpoints: c.breakpoints || undefined,
      watchOverflow: true,
      rewind: !loop && !!c.rewind,
      grabCursor: true
    };
    var prev = wrap.querySelector('.dn-sw-prev');
    var next = wrap.querySelector('.dn-sw-next');
    if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
    if (c.scrollbar) opts.scrollbar = { el: el.querySelector('.swiper-scrollbar'), draggable: true };
    if (c.autoplay && loop && !reduce) {
      opts.autoplay = {
        delay: c.autoplay.delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: c.marquee ? false : true
      };
      if (c.marquee) { opts.allowTouchMove = false; el.classList.add('dn-sw--marquee'); }
    }
    el.__dnSwiper = new Swiper(el, opts);
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-dn-swiper]').forEach(start);
  }

  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
